import React from 'react'
import { QuestionOutlineIcon } from '@chakra-ui/icons'
import { Flex, VStack, Container, Text, Heading, Tooltip } from '@chakra-ui/react'

import { QuestionType } from 'modules/questions'
import { FormField, WizardStepForm } from 'components'

import {
  FormAnswerBinary,
  FormAnswerLikert3,
  FormAnswerLikert5,
  FormAnswerLikert7,
  FormAnswerMultiple
} from '../components'
import { useFormDetailQuery } from '../hooks'

const FormAnswerComponents = {
  [QuestionType.BINARY]: FormAnswerBinary,
  [QuestionType.LIKERT3]: FormAnswerLikert3,
  [QuestionType.LIKERT5]: FormAnswerLikert5,
  [QuestionType.LIKERT7]: FormAnswerLikert7,
  [QuestionType.MULTIPLE]: FormAnswerMultiple
}

const FormQuestion = ({
  id,
  type,
  text,
  description,
  notApplicable,
  options,
  index,
  answerIndex,
  ...props
}) => {
  const Component = FormAnswerComponents[type]

  return (
    <Flex p={3}>
      <Text fontSize='xl' px={2} textAlign='right' width='50px' minWidth='50px'>
        {index + 1})
      </Text>
      <Flex direction='column'>
        <Text fontSize='xl' mb={3}>
          {text}
          <Tooltip label={description} fontSize='md'>
            <QuestionOutlineIcon boxSize={4} ml={1} verticalAlign='top' />
          </Tooltip>
        </Text>
        <FormField
          isRequired // ={type !== QuestionType.MULTIPLE}
          name={`answers[${id}].answer`}
          render={<Component notApplicable={notApplicable} options={options} />}
        />
        <FormField
          defaultValue={id}
          name={`answers[${id}].question.id`}
          render={<input type='hidden' />}
        />
      </Flex>
    </Flex>
  )
}

const TEXT = {
  Responsabilização:
    'Uma das dimensões da IA que gera maior controvérsia é a responsabilidade, sendo igualmente o conceito que mais contribui para a sustentabilidade de um framework ético de um sistema de IA. A sua materialização dá-se quando os sistemas de IA apresentam execução de responsabilidades e possibilidade plena de auditoria/ inspeção. A responsabilização integra os indivíduos responsáveis pelas partes que desempenham num fluxo de trabalho complexo num sistema de IA, desde a conceção à sua implementação. E daí advém uma responsabilidade distribuída, em cadeia.',
  Transparência:
    'A transparência de um sistema de IA cumpre-se quando os algoritmos asseguram a visualização dos seus componentes e dos procedimentos aplicados, isto é, quando é possível a rastreabilidade completa do ciclo de procedimentos de desenvolvimento desse sistema. Essa é garantida pela apropriada documentação de dados e processos que geram as decisões do sistema de IA, incluindo a informação relativa à recolha, ao armazenamento e à utilização de dados, e ainda a comunicação clara das suas capacidades e limitações.',
  Explicabilidade:
    'A explicabilidade é conseguida quando é possível explicar, verificar e reproduzir os processos técnicos implícitos, o raciocinio, as decisões e a utilização dos dados por sistemas de IA. Esta dimensão garante a possibilidade de interpretação dos sistemas e a compreensão das implicações dos resultados/ impactos decorrentes, esperados ou não. A transparência e a explicabilidade são duas dimensões complementares, uma vez que a primeira consolida o cumprimento da segunda.',
  Justiça:
    'A justiça é um conceito que se refere ao estado ideal de ausência de preconceito ou favoritismo direcionado a um individuo ou grupo, com base nas suas características herdadas ou adquiridas. Este engloba os ideais de equidade, imparcialidade, igualitarismo e não discriminação. A construção de um sistema de IA justo implica que seja inclusivo da diversidade na sua conceptualização, de modo a evitar a introdução ou criação de viés. Os produtos de IA devem ainda dirigir-se a todos os utilizadores e incorporar garantias e salvaguardas aos utilizadores e beneficiários.',
  Ética:
    'Um sistema de IA ético é aquele que releva o respeito pelo homem, o respeito pelos direitos humanos, a participação e a responsabilidade pelas escolhas e decisões, e que prioriza o benefício e a proteção do individuo e dos bens comuns à sociedade. Neste sentido, um código de ética permitirá a projeção de um conjunto de valores, princípios e diretrizes que acompanhem os desenvolvimentos tecnológicos, bem como, os elementos sociais e políticos associados. A sua aplicação deve estar assegurada em todas as fases do ciclo de um sistema de IA e deve ser cumprida por todos os indivíduos associados.'
}

export const FormSubmissionStep = ({ formId, dimension, ...props }) => {
  const form = useFormDetailQuery(formId)

  return (
    <WizardStepForm {...props}>
      <Heading size='2xl' textAlign='center' my={5}>
        {dimension.name}
      </Heading>
      <Container my={5}>
        <VStack align='stretch'>
          <Text my={4} align='center'>
            {TEXT[dimension.name]}
          </Text>
          {form.data?.questions
            .map((question, index) => ({ ...question, answerIndex: index }))
            .filter(question => question.dimension.id === dimension.id)
            .map((question, index) => (
              <FormQuestion {...question} index={index} key={question.answerIndex} />
            ))}
        </VStack>
      </Container>
    </WizardStepForm>
  )
}

export default FormSubmissionStep
